import styled from '@emotion/styled';
import { pxToEm, theme } from 'theme';

type IconProps = {
  dense?: boolean;
  fontSize?: number;
  isWithLabel?: boolean;
  color?: string;
};

export const Label = styled.span`
  max-width: 0;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.8em;
  font-weight: 700;
  color: inherit;
  transition: all 0.4s ease-in-out;
`;

export const Icon = styled.span<IconProps>`
  display: inline-flex;
  align-items: center;
  border-radius: 2em;
  padding: ${(props) => (props.dense ? '0' : '0.5em')};
  font-size: ${({ fontSize = 1 }) => `calc(1em * ${fontSize})`} !important;
  svg {
    width: ${pxToEm(24)};
    height: auto;
    aspect-ratio: 1/1;
    ${({ color }) => color && `color: ${color};`}
  }
  img {
    width: ${pxToEm(24)};
    height: auto;
    aspect-ratio: 1/1
  }
  ${theme.breakpoints.up('md')} {
    transition: padding 0.4s ease-in-out;
    &:hover {
      ${(props) =>
        !props.dense && props.isWithLabel ? 'padding: 0.5em 1em;' : ''}
      ${(props) =>
        props.isWithLabel
          ? `& > span {
          margin: 0 0.75em;
          max-width: 20em;
        }
        `
          : ''};
    }
  }
}
`;
